/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AccountNav.vue?vue&type=template&id=dc425c7e&scoped=true"
import script from "./AccountNav.vue?vue&type=script&lang=js"
export * from "./AccountNav.vue?vue&type=script&lang=js"
import style0 from "./AccountNav.vue?vue&type=style&index=0&id=dc425c7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc425c7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc425c7e')) {
      api.createRecord('dc425c7e', component.options)
    } else {
      api.reload('dc425c7e', component.options)
    }
    module.hot.accept("./AccountNav.vue?vue&type=template&id=dc425c7e&scoped=true", function () {
      api.rerender('dc425c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/AccountNav.vue"
export default component.exports